import { GoToMealsRequest } from "@/clients/models/GoToMealsRequest";
import { MealTime } from "@/clients/models/MealTime";
import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation } from "@tanstack/react-query";

export const useGenerateCandidate = (mealTime: MealTime) => {
  const mutation = useMutation({
    mutationKey: [QueryKeys.GO_TO_CANDIDATE, mealTime],
    mutationFn: async (requestBody: GoToMealsRequest) => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await MealsService.generateGotoMealCandidatesApiV1MealsGotoCandidatesMealTimePost(
          mealTime,
          user.id,
          requestBody,
        );
      return data;
    },
  });

  return {
    generateCandidate: mutation.mutate,
    generateCandidateAsync: mutation.mutateAsync,
    isGenerating: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    response: mutation.data,
  };
};
